import BranchSummaryDto from "@/models/Branches/BranchSummaryDto";
import AgencyUserSummaryDto from "@/models/AgencyUsers/AgencyUserSummaryDto";
import WorkerSummaryDto from "@/models/Workers/WorkerSummaryDto";
import BookingLocationSummaryDto from "@/models/Locations/BookingLocationSummaryDto";
import BookingRequirementsSummaryDto from "@/models/Bookings/BookingRequirementsSummaryDto";
import ShiftSummaryDto from "@/models/Shifts/ShiftSummaryDto";
import AgencyIdentifierDto from "@/models/Agencies/AgencyIdentifierDto";


export default class AnonBookingRoleWorkerDto {
    bookingRoleWorkerId = '';
    updatedAt: Date;
    allowDeclineBooking = false;
    url = '';
    instructions = '';
    agencyIdentifier: AgencyIdentifierDto = new AgencyIdentifierDto();
    agencyBranch: BranchSummaryDto = new BranchSummaryDto();
    agencyOwner: AgencyUserSummaryDto = new AgencyUserSummaryDto();
    worker: WorkerSummaryDto = new WorkerSummaryDto();
    location: BookingLocationSummaryDto = new BookingLocationSummaryDto();
    requirements: BookingRequirementsSummaryDto = new BookingRequirementsSummaryDto();
    shifts: ShiftSummaryDto[] = []; 
}
